// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__22DyK","file":"styles_file__vv2VY"};